import {action, makeObservable, observable} from 'mobx';

const ONE_SECOND = 1000;

export class CurrentTimeStore {
    private baseServerTime: number | null = null;

    private baseLocalTime: number | null = null;

    constructor() {
        makeObservable(this);
        setInterval(() => this.tick(), ONE_SECOND);
    }

    @observable t: number | null = null;

    @action setTime(time: number): void {
        this.baseServerTime = time;
        this.baseLocalTime = Date.now();
        this.t = time;
    }

    @action private tick(): void {
        if (this.baseServerTime !== null && this.baseLocalTime !== null) {
            this.t = this.baseServerTime + Math.floor((Date.now() - this.baseLocalTime) / ONE_SECOND);
        }
    }
}
